<app-dialog>
  <div header>About</div>
  <div content>
    <p style="font-weight: bold;">General</p>
    <div
      style="display: flex; flex-direction: column; gap: 5px; border-radius: 4px; padding: 4px; background: var(--theme-entry-background-color);">
      Serverversion: {{environmentVersion}}
      <br>
      Clientversion: {{config?.clientVersion}}
    </div>


    <p style="font-weight: bold;">Credits</p>
    <div
      style="display: flex; flex-direction: column; gap: 5px; border-radius: 4px; padding: 4px; background: var(--theme-entry-background-color);">
      <a (click)="openLink('https://www.flaticon.com/free-icons/incoming-call')" title="incoming call icons">Incoming
        call icons
        created
        by SeyfDesigner - Flaticon</a>
      <a (click)="openLink('https://www.flaticon.com/free-icons/user')" title="user icons">User icons created by
        Freepik -
        Flaticon</a>
      <a (click)="openLink('https://www.flaticon.com/free-icons/copy')" title="copy icons">Copy icons created by
        Catalin Fertu -
        Flaticon</a>
      <a (click)="openLink('https://www.flaticon.com/free-icons/success')" title="success icons">Success icons created
        by dmitri13 -
        Flaticon</a>
      <a (click)="openLink('https://www.flaticon.com/uicons')" title="UIcons">UIcons by Flaticon</a>
    </div>
    <p><fluent-divider /></p>
    <div style="display: grid; justify-items: center;">
      <p style="font-weight: bold;">© Medialine Communications GmbH</p>
      <div>
        <a (click)="openLink('https://service.medialine.ag/intranet/display/XKB/Data+Privacy+Statement')"
          title="Privacy Statement">Privacy Statement</a> | <a
          (click)="openLink('https://service.medialine.ag/intranet/display/XKB/License+Agreement')"
          title="License Agreement">License Agreement</a>
      </div>
    </div>
  </div>
  <fluent-button (click)="close()" actions>Close</fluent-button>
</app-dialog>